var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodataBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197.3 123.2",
    style: {
      enableBackground: "new 0 0 197.3 123.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DADADA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.3,100.8c-0.1-0.6-0.6-1-1.2-1c-9.7,0-17.5-7.1-19.2-8.6V46.6c0-0.6-0.4-1-0.9-1.2l-53-11 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3,0-0.4,0.1c0,0,0,0,0,0c0,0,0,0,0,0L81.1,53.1 c-0.4,0.2-0.7,0.6-0.7,1.1l1.9,48.2c-5.5,10.1-16.9,18.5-17,18.6c-0.5,0.4-0.6,1-0.3,1.5c0.2,0.4,0.6,0.6,1,0.6 c0.1,0,0.3,0,0.4-0.1l45.7-17.7l16.9,0.9c3.5,12.6,20,13.2,23,13.2c0.3,0,0.5,0,0.5,0c0.1,0,0.3,0,0.4-0.1l43.7-17.3 C197.1,101.9,197.4,101.3,197.3,100.8z M129.7,104l-14.7-0.8c6-5.6,8.6-12.7,9.5-15.7l45.2,4.7L129.7,104z M174.6,90.4l-49.8-5.2 l-0.8-48.1l50.7,10.5V90.4z M121.6,37.4l0.9,48L84.6,101l-1.8-46L121.6,37.4z M84.3,103.7l37.4-15.3c-1.2,3.5-4.3,10.3-10.4,14.9 l-39,15.1C76.2,114.7,81.1,109.5,84.3,103.7z M152.1,117.1c-1.9,0-17.5-0.1-20.8-11.1l44.1-13c1.8,1.7,7.8,7,15.8,8.6L152.1,117.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.9,95c-0.8-0.2-18.2-5.1-32.4,4.2c-12.3-3.6-27.1,4.7-27.9,5.2c-0.6,0.3-0.8,1.1-0.4,1.6 c0.3,0.6,1,0.8,1.6,0.4c0.2-0.1,13-7.4,24.1-5.3c-4,3.3-5.6,6.3-4.8,8.9c1,3.2,5.1,4.5,8.6,4.8c0.4,0,0.7,0,1.1,0 c3.3,0,7-0.9,8.3-3.6c0.7-1.4,0.8-3.8-2.3-7c-1.7-1.7-3.5-3-5.5-4c13.1-7.4,28.8-3.1,29-3c0.6,0.2,1.3-0.2,1.5-0.8 C61.9,95.9,61.5,95.2,60.9,95z M35.1,105.9c1,1,2.6,3,1.9,4.4c-0.7,1.5-3.7,2.4-7.1,2.2c-3.4-0.2-6-1.5-6.5-3.1 c-0.5-1.6,1-3.9,4.1-6.5c0.4-0.4,0.9-0.7,1.3-1C31.1,102.7,33.2,104,35.1,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,67.5c0.6,0.3,12.3,6.3,21.9,3.2c4.9,2.9,10.2,3.7,14.7,3.7c5.9,0,10.3-1.4,10.7-1.6 c0.6-0.2,1-0.9,0.8-1.5c-0.2-0.6-0.9-1-1.5-0.8c-0.1,0-11.8,3.8-21.9-1.2c1.3-0.8,2.6-1.8,3.8-3.1c2.4-2.7,2.2-4.7,1.6-5.8 c-1.2-2.4-4.9-2.9-7.7-2.6c-2.8,0.3-6.1,1.5-6.8,4.2c-0.6,2.1,0.7,4.4,3.7,6.7c-8.3,1.5-18-3.4-18.1-3.5c-0.6-0.3-1.3-0.1-1.6,0.5 C20.9,66.5,21.2,67.2,21.8,67.5z M39.6,62.8c0.3-1.2,2.3-2.2,4.7-2.4c0.4,0,0.8-0.1,1.2-0.1c2,0,3.6,0.5,4.1,1.4 c0.3,0.7-0.1,1.8-1.3,3.1c-1.3,1.5-2.8,2.5-4.5,3.2c-0.3-0.2-0.6-0.4-0.9-0.6C40.5,65.6,39.3,63.9,39.6,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,82.5c0.9,0,1.5,0,1.6,0c0.7,0,1.2-0.6,1.1-1.2c0-0.7-0.6-1.2-1.2-1.1C34.1,80.1,13.6,81,2,69.6 c-0.5-0.5-1.2-0.5-1.7,0c-0.5,0.5-0.5,1.2,0,1.7C10.8,81.6,27.6,82.5,32.8,82.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,0.1V9h-2.2l-3.6-5.5V9h-2.2V0.1h2.2l3.6,5.5V0.1H54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,9.1c-2.5,0-4.6-1.9-4.6-4.5s2-4.5,4.6-4.5c2.5,0,4.5,1.9,4.5,4.5S62.7,9.1,60.2,9.1z M60.2,7.1 c1.4,0,2.3-1,2.3-2.6C62.5,3,61.6,2,60.2,2c-1.4,0-2.4,1-2.4,2.6C57.8,6.1,58.7,7.1,60.2,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.8,4.6C76.8,7.2,75,9,72.2,9h-3.3V0.1h3.3C75,0.1,76.8,1.9,76.8,4.6z M72,7.1c1.6,0,2.6-0.9,2.6-2.6 S73.6,2,72,2h-1v5.2H72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,7.4h-3.3L79.8,9h-2.3l3.2-8.9h2.5L86.5,9h-2.3L83.7,7.4z M82,2.5l-1.1,3.2h2.2L82,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,0.1H94v1.7h-2.4V9h-2.2V1.9h-2.4V0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.7,7.4h-3.3L96.9,9h-2.3l3.2-8.9h2.5l3.2,8.9h-2.3L100.7,7.4z M99,2.5L98,5.8h2.2L99,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,0.1h5.8v1.7h-3.6v1.9h2.7v1.7h-2.7V9h-2.2V0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.6,9.1c-2.5,0-4.6-1.9-4.6-4.5s2-4.5,4.6-4.5c2.5,0,4.5,1.9,4.5,4.5S121.2,9.1,118.6,9.1z M118.6,7.1 c1.4,0,2.3-1,2.3-2.6c0-1.6-0.9-2.6-2.3-2.6c-1.4,0-2.3,1-2.3,2.6C116.3,6.1,117.2,7.1,118.6,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,0.1h2.2v5.3c0,1,0.5,1.7,1.5,1.7c1,0,1.6-0.6,1.6-1.7V0.1h2.2v5.3c0,2.5-1.7,3.7-3.8,3.7 c-2.1,0-3.7-1.2-3.7-3.7V0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.5,0.1V9h-2.2l-3.6-5.5V9h-2.2V0.1h2.2l3.6,5.5V0.1H141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.1,4.6c0,2.6-1.8,4.4-4.6,4.4h-3.3V0.1h3.3C149.3,0.1,151.1,1.9,151.1,4.6z M146.4,7.1 c1.6,0,2.6-0.9,2.6-2.6S148,2,146.4,2h-1v5.2H146.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataBox);
export default __webpack_public_path__ + "static/media/NODATA-BOX.49e6dadba3852f4913d7bccd4b47b45f.svg";
export { ForwardRef as ReactComponent };